import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  amount: '',
  createdBy: '',
  contributedBy: '',
  paymentMethod: '',
  from: '',
  to: '',
}

const capitalFilter = createSlice({
  name: 'capitalFilter',
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state[action.payload.property] = action.payload.value
    },
  },
})

export const { setFilter } = capitalFilter.actions
export default capitalFilter.reducer
